/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Spin, Upload, message } from 'antd'
import { ImagePlus } from 'lucide-react'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'

const Dragger = Upload.Dragger

export const CompanyLogo = () => {
  const company = useCompanyStore((state) => state.company)
  const api = useApi()
  const [loading, setLoading] = React.useState(false)

  const handleUpload = async ({ file }: any) => {
    setLoading(true)
    try {
      if (!(file instanceof File)) {
        throw new Error('Invalid file')
      }

      const objectUrl = await api.uploadImage(file)
      api.syncCompany({ logo: objectUrl })
    } catch {
      message.error('Failed to upload logo')
    }
    setLoading(false)
  }

  return (
    <Spin style={{ width: 150, height: 150 }} spinning={loading}>
      <Dragger
        accept="image/*"
        listType="picture-card"
        showUploadList={false}
        customRequest={handleUpload}
        style={{
          width: '100%',
          height: '100%',
          [!company.logo ? 'null' : 'border']: 'none',
          background: !company.logo ? '#f9fafb' : 'white'
        }}
        className={`w-[150px] h-[150px] flex-shrink-0 rounded-lg ${!company.logo ? 'bg-gray-50' : 'bg-white'}`}
      >
        {company.logo ? (
          <div className="w-full h-full flex items-center justify-center p-0">
            <img
              src={company.logo}
              alt="Company Logo"
              className="max-w-full max-h-full object-contain cursor-pointer hover:opacity-90 transition-opacity"
            />
          </div>
        ) : (
          <div
            className="w-full h-full rounded-lg flex items-center justify-center cursor-pointer hover:border-blue-500 transition-colors"
            style={{ borderColor: company.settings.primaryColor + '40' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
              }}
              className="text-center"
            >
              <ImagePlus
                className="h-8 w-8 mb-2"
                style={{ color: company.settings.primaryColor }}
              />
              <span className="text-sm text-gray-500">Upload Logo</span>
            </div>
          </div>
        )}
      </Dragger>
    </Spin>
  )
}
